import { action } from 'satcheljs';
import {
    DraftSaveCalendarViewConfig,
    SaveCalendarViewConfig,
} from '../store/schema/SaveCalendarViewConfig';

export const loadSavedCalendarViews = action('loadSavedCalendarViews');

export const addSavedCalendarView = action(
    'addSavedCalendarView',
    (draftSaveCalendarViewConfig: DraftSaveCalendarViewConfig) => ({
        draftSaveCalendarViewConfig,
    })
);

export const editSavedCalendarView = action(
    'editSavedCalendarView',
    (currentlyEditedView: SaveCalendarViewConfig) => ({
        currentlyEditedView,
    })
);

export const updateCurrentlyDisplayedViewId = action(
    'updateCurrentlyDisplayedViewId',
    (id: string) => ({
        id,
    })
);

export const deleteSavedCalendarView = action('deleteSavedCalendarView', (id: string) => ({
    id,
}));
